import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PhoneMockup = ({ src, alt, size = 'normal' }) => {
  const dimensions = size === 'large' ? 'h-[560px] w-[270px]' : 'h-[390px] w-[188px]';
  const radius = size === 'large' ? 'rounded-[2.7rem]' : 'rounded-[2rem]';
  const innerRadius = size === 'large' ? 'rounded-[2.1rem]' : 'rounded-[1.55rem]';
  const islandSize = size === 'large' ? 'h-4 w-16' : 'h-3.5 w-14';

  return (
    <div className={`relative mx-auto ${dimensions}`}>
      <div className="absolute inset-x-4 top-12 h-64 rounded-full bg-[#7f49f5]/25 blur-3xl" />
      <div className={`absolute inset-0 bg-[#050507] p-2 shadow-2xl shadow-black/70 ${radius}`}>
        <div className={`absolute left-1/2 top-3 z-10 ${islandSize} -translate-x-1/2 rounded-full bg-black`} />
        <div className={`h-full overflow-hidden bg-black ${innerRadius}`}>
          <img
            src={src}
            alt={alt}
            className="h-full w-full object-cover"
            style={{ objectPosition: 'center top' }}
            onError={(e) => {
              if (e.target.src.includes('.png')) {
                e.target.src = src.replace('.png', '.jpeg');
              } else {
                e.target.style.display = 'none';
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

const Screenshots = () => {
  const { t } = useLanguage();

  const screenshots = t('screenshots.items');
  const screenshotList = Array.isArray(screenshots) ? screenshots.slice(1) : [];

  return (
    <section id="capturas" className="relative scroll-mt-28 overflow-hidden bg-black py-24 text-[#fffefa] sm:py-28">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/[0.16] to-transparent" />
      <div className="absolute left-1/2 top-24 h-[28rem] w-[56rem] -translate-x-1/2 rounded-full bg-[#1a002f]/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-16 max-w-4xl text-center">
          <div className="mb-5 text-xs font-medium uppercase text-[#0a84ae]">FARM</div>
          <h2 className="text-4xl font-normal leading-tight tracking-normal text-white sm:text-5xl lg:text-[56px]">
            {t('screenshots.title1')}{' '}
            <span className="text-[#d2c0ff]">{t('screenshots.titleHighlight')}</span>{' '}
            {t('screenshots.title2')}
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-[#b7b5c2]">
            {t('screenshots.subtitle')}
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {screenshotList.map((screenshot, index) => (
            <article key={screenshot.title} className="grid gap-8 rounded-[24px] border border-white/10 bg-[#0b0b0f] p-7 shadow-[inset_0_1px_0_rgba(255,255,255,0.1)] sm:grid-cols-[220px_1fr] sm:items-center sm:p-8">
              <PhoneMockup src={`/farm-screenshot-${index + 2}.png`} alt={`FARM app screenshot ${index + 2}`} size="compact" />
              <div>
                <h3 className="text-2xl font-normal text-white">{screenshot.title}</h3>
                <p className="mt-3 leading-7 text-[#b7b5c2]">{screenshot.description}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {Array.isArray(screenshot.features) && screenshot.features.map((feature) => (
                    <span key={feature} className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-2 text-xs text-[#c9c8d0]">
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
